import memoize from "lodash/memoize";

export const memoizeFocalPoint = memoize(
  ({ focalX, focalY, width, height }) => ({
    focalX,
    focalY,
    width,
    height,
  }),
  ({ focalX, focalY, width, height }) =>
    [focalX, focalY, width, height].join("|"),
);
